export interface IAnimationExampleProps {
  animation: string;
}
